import { IntentOption } from './types';

const ALL_ACTIVITY_OPTIONS: IntentOption[] = [
  {
    key: 'view_membership_card',
    title: 'View membership card',
    description: 'Access your active memberships',
  },
  {
    key: 'view_event_tickets',
    title: 'View event tickets',
    description: "See and share tickets you've already purchased",
  },
  {
    key: 'view_purchase_history',
    title: 'View purchase history',
    description: 'Review what you’ve bought and paid for',
  },
  {
    key: 'view_cash_back_earned',
    title: 'View cash back earned',
    description: 'See how much you’ve earned for your organizations',
  },
] as const;

const SUPPORT_OPTIONS: IntentOption[] = [
  {
    key: 'buy_a_membership',
    title: 'Buy a membership',
    description: 'e.g. PTA, booster club',
  },
  {
    key: 'support_a_fundraiser',
    title: 'Support a fundraiser',
    description: 'e.g. school campaigns or a-thons',
  },
  {
    key: 'buy_a_store_item',
    title: 'Buy a store item',
    description: 'e.g. spirit wear, key chains',
  },
  {
    key: 'check_out_shop_to_give',
    title: 'Check out Rewards',
    description: 'Shop online & give back automatically',
  },
  {
    key: 'pay_a_student_fee',
    title: 'Pay a student fee',
    description: 'e.g. class trips, club dues',
  },
  {
    key: 'buy_a_ticket',
    title: 'Buy an event ticket',
    description: 'e.g. school plays, sports, dances',
  },
  {
    key: 'make_a_donation',
    title: 'Make a donation',
    description: 'Give directly to a school or nonprofit',
  },
] as const;

export { ALL_ACTIVITY_OPTIONS, SUPPORT_OPTIONS };
